<template>
  <div class="play-unsolicited-effect">
    <unsolicited-items
      :emitter="emitter"
      :items="emitter.caseConf.dialogue.unsolicited"
      :selected="state.effect.id"
      :control="control"
      :readonly="readonly"
      @update="selectUnsolicited"
    />
    <div class="el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">To</div>
      <character-select
        :selected="state.effect.targetCharacterKey"
        :characters="getTargetCharacters(emitter.caseConf)"
        :disabled="readonly"
        :errors="missingTargetCharacterErrors"
        placeholder="Select Target Character"
        @input="selectTargetCharacter"
      />
    </div>
    <wait-for-previous-checkbox
      :value="waitForPrevious"
      :disabled="readonly || !hasUnsolicitedPredecessor"
      @change="selectWaitForPrevious"
    />
  </div>
</template>

<script>
import { getTargetCharacters } from '~lib/common/utils/characters';
import nodeMixins from './mixins/NodeMixins';

import CharacterSelect from './CharacterSelect.vue';
import UnsolicitedItems from './UnsolicitedItems.vue';
import WaitForPreviousCheckbox from './common/WaitForPreviousCheckbox.vue';
import waitForPreviousMixins, { PATIENT } from './mixins/WaitForPreviousMixins';

export default {
  name: 'play-unsolicited-effect',
  components: {
    WaitForPreviousCheckbox,
    CharacterSelect,
    UnsolicitedItems,
  },
  mixins: [ nodeMixins, waitForPreviousMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {},
      },
    };
  },
  computed: {
    // in waitForPreviousMixins
    waitForPreviousSpeaker() {
      return this.state.effect.sourceCharacterKey || PATIENT;
    },
    missingTargetCharacterErrors() {
      return this.getErrorsById('missingTargetCharacter');
    },
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.emitter.trigger('process', this.control);
  },
  methods: {
    syncState() {
      const data = this.getData(this.ikey);
      this.state.effect = data || {};
      this.loadWaitForPrevious(data);
      // Legacy effects were saved before target characters existed and have no
      // targetCharacterKey at all; default those to user (PROVIDER) so loading an
      // existing case doesn't cause a missingTargetCharacter error. An explicit
      // null means a new node still awaiting a selection, so leave it alone.
      if (this.state.effect.id && this.state.effect.targetCharacterKey === undefined) {
        this.state.effect.targetCharacterKey = 'user';
        this.update();
      }
    },
    selectUnsolicited(unsolicitedId) {
      this.state.effect.id = unsolicitedId;
      // Mark a new node null so it requires an explicit
      // choice instead of being silently defaulted to User by syncState.
      if (this.state.effect.targetCharacterKey === undefined) {
        this.state.effect.targetCharacterKey = null;
      }
      this.update();
    },
    selectTargetCharacter(key) {
      this.state.effect.targetCharacterKey = key;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'UNSOLICITED_DIALOGUE',
        ...this.state.effect,
        // waitForPreviousMixins reconciles this value.
        waitForPrevious: this.waitForPrevious,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
    getTargetCharacters,
  },
};
</script>

<style scoped>
</style>
